<template>
  <v-flex xs8>
    <v-flex
      xs12
      class="p-3"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <v-flex v-if="selectedKeyWordObject != null && !isSingleKeyWordLoading">
        <div v-if="!newMode">
          <button
            v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
            v-b-tooltip.hover
            v-b-modal.confirmDeleteKeyWord
            type="button"
            placement="bottom"
            title="Stichwort löschen"
            class="btn btn-danger float-right ml-1"
          >
            <i class="fas fa-trash-alt" />
          </button>
          <b-modal
            id="confirmDeleteKeyWord"
            ref="confirmDeleteKeyWord"
            hide-footer
            title="Stichwort löschen"
            no-fade
          >
            <div class="d-block mb-4">
              Sind Sie sicher, dass Sie dieses Stichwort löschen möchten
            </div>
            <b-button
              variant="success"
              @click="
                hideModal();
                deleteSelectedKeyWord();
              "
            >
              Ok
            </b-button>
            <b-button
              class="ml-2"
              variant
              @click="hideModal"
            >
              Abbrechen
            </b-button>
          </b-modal>
          <button
            v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
            v-b-tooltip.hover
            type="button"
            placement="bottom"
            title="Stichwort bearbeiten"
            class="btn btn-primary float-right"
            @click="editMode = !editMode"
          >
            <i class="fas fa-edit" />
          </button>
        </div>

        <h4 class="mb-4">
          {{ selectedKeyWordObject.code }}
        </h4>

        <div v-if="!editMode">
          <v-container class="pb-0 pt-0">
            <v-layout row>
              <v-flex xs3>
                <label
                  for="filter"
                  class="pl-0 col-3 defaultLabel"
                >Übersetzung</label>
              </v-flex>
              <v-flex
                xs9
                class="viewModeValue"
              >
                <ul>
                  <li>
                    <strong>DE</strong>
                    {{
                      getContentForLanguage(
                        selectedKeyWordObject.keywordContents,
                        "de-CH",
                      )
                    }}
                  </li>
                  <li>
                    <strong>FR</strong>
                    {{
                      getContentForLanguage(
                        selectedKeyWordObject.keywordContents,
                        "fr-CH",
                      )
                    }}
                  </li>
                  <li>
                    <strong>IT</strong>
                    {{
                      getContentForLanguage(
                        selectedKeyWordObject.keywordContents,
                        "it-CH",
                      )
                    }}
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container class="pb-0 pt-0">
            <v-layout row>
              <v-flex xs3>
                <label
                  for="filter"
                  class="pl-0 defaultLabel"
                >Original Sprache</label>
              </v-flex>
              <v-flex
                xs9
                class="viewModeValue"
              >
                {{ selectedKeyWordObject.originalLanguage }}
              </v-flex>
            </v-layout>
          </v-container>

          <v-container class="pb-0 pt-0">
            <v-layout row>
              <v-flex xs3>
                <label
                  for="filter"
                  class="pl-0 defaultLabel"
                >Zugeordnete Verträge</label>
              </v-flex>
              <v-flex xs9>
                <ul>
                  <li
                    v-for="(
                      contract, index
                    ) in selectedKeyWordObject.keywordContracts"
                    :key="index"
                    class="keyWordPropertyListItem viewModeValue"
                  >
                    <router-link
                      :to="'/contract-overview/' + contract.contractNumber"
                    >
                      {{ contract.contractNumber }} -
                      {{ getContractName(contract.contractNumber) }}
                    </router-link>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <div v-else>
          <div class="form-group">
            <v-container>
              <v-layout row>
                <label
                  for="filter"
                  class="pl-0 col-3 defaultLabel"
                >Stichwort Titel*</label>
                <div class="col-9 pr-0">
                  <v-text-field
                    v-model="selectedKeyWordObject.code"
                    required
                  />
                </div>
              </v-layout>
            </v-container>
          </div>
          <div class="form-group">
            <v-container>
              <v-layout row>
                <label
                  for="filter"
                  class="pl-0 col-3 defaultLabel"
                >Übersetzung</label>
                <div class="col-9 pr-0">
                  <u-multiline-multilanguage-text-input
                    v-model="selectedKeyWordObject.keywordContents"
                    content-property-name="value"
                  />
                </div>
              </v-layout>
            </v-container>
          </div>
          <div class="form-group">
            <v-container class="pb-0 pt-0">
              <v-layout row>
                <label
                  for="filter"
                  class="pl-0 col-3 defaultLabel"
                >Original Sprache*</label>
                <div class="col-9 viewModeValue">
                  <v-select
                    v-model="selectedKeyWordObject.originalLanguage"
                    :items="originalLanguages"
                    placeholder="Sprache wählen"
                  />
                </div>
              </v-layout>
            </v-container>
          </div>
          <div class="form-group contractSelection">
            <v-container class="pb-2 pt-2">
              <v-layout row>
                <label
                  for="exampleInputEmail1"
                  class="pl-0 col-3 defaultLabel"
                >Zugeordnete Verträge</label>
                <div class="col-9">
                  <div
                    id="anchorForMultiselectContracts"
                    class="anchorForMultiselect"
                  />
                  <v-autocomplete
                    v-model="selectedKeyWordObject.keywordContracts"
                    :items="allContracts"
                    attach="#anchorForMultiselectContracts"
                    multiple
                    return-object
                    item-value="contractNumber"
                    :filter="filterContracts"
                    hint="Zugeordnete Verträge auswählen"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <div class="m-2 mutliselectSelectionItem">
                        {{ data.item.contractName }}
                        <button @click="removeContract(data.item)">
                          <i class="fas fa-times" />
                        </button>
                      </div>
                    </template>

                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <div :id="data.item.contractNumber">
                        {{ data.item.contractNumber }} -
                        {{ data.item.contractName }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
              </v-layout>
            </v-container>
          </div>
          <div class="buttonContainer pt-4">
            <b-button
              variant="success"
              @click="saveCreateKeyWord"
            >
              Speichern
            </b-button>

            <b-button
              class="ml-2"
              variant="danger"
              @click="cancelEditingKeyword"
            >
              Abbrechen
            </b-button>
          </div>
        </div>
      </v-flex>

      <v-flex
        v-else-if="isSingleKeyWordLoading"
        xs12
        justify-center
      >
        <u-loader />
      </v-flex>

      <v-flex v-else>
        Wählen Sie ein Stichwort aus um es zu verwalten
      </v-flex>
    </v-flex>

    <v-flex xs12>
      <button
        v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
        v-b-tooltip.hover
        type="button"
        title="Neues Stichwort erstellen"
        class="btn btn-success float-right"
        @click="createNewKeyWord"
      >
        <i class="fas fa-plus" />
      </button>
    </v-flex>
  </v-flex>
</template>

<script>
import { MultiLangMixin } from "@/mixins/MultilanguageContentsMixin";

import {
  AddKeyword,
  GetKeyword,
  UpdateKeyword,
  DeleteKeyword,
} from "@/services/keywords.service.js";

import { GetAllContractsNoVersions } from "@/services/contract.service.js";

export default {
  mixins: [MultiLangMixin],

  data() {
    return {
      keywordId: null,
      selectedKeyWord: null,
      editMode: false,
      newMode: false,
      allKeyWords: [],
      selectedKeyWordObject: null,
      previousSelectedKeyWordObject: null,
      isSingleKeyWordLoading: false,
      allNogaBranchen: [],
      allProfessions: [],
      allContracts: [],
      errorObject: null,
      originalLanguages: ["de-CH", "fr-CH", "it-CH"],
      previousSelectedKeyWordId: -1,
    };
  },

  watch: {
    $route(to) {
      this.keywordId = to.params.keywordId;

      if (this.keywordId != null) {
        this.loadSingleKeyword(this.keywordId);
      }
    },
  },

  created() {
    this.errorObject = null;
    this.keywordId = this.$route.params.keywordId;

    if (this.keywordId != null) {
      this.loadSingleKeyword(this.keywordId);
    }

    GetAllContractsNoVersions(
      (result) => {
        this.allContracts = result.data;
      },
      (error) => {
        console.log(error);
        this.errorObject = error;
      },
    );
  },

  methods: {
    saveCreateKeyWord() {
      this.errorObject = null;
      if (this.newMode) {
        this.addNewKeyWord();
      } else {
        this.saveKeyWord();
      }
    },
    saveKeyWord() {
      this.isLoading = true;

      UpdateKeyword(
        this.selectedKeyWordObject,
        this.selectedKeyWordObject.id,
        () => {
          this.editMode = false;
          this.isLoading = false;

          this.$emit("keyword-updated", this.selectedKeyWordObject);
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    addNewKeyWord() {
      AddKeyword(
        this.selectedKeyWordObject,
        (addedKeyword) => {
          this.editMode = false;
          this.isLoading = false;

          this.$emit("keyword-added", addedKeyword);
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    hideModal() {
      this.$refs["confirmDeleteKeyWord"].hide();
    },
    createNewKeyWord() {
      this.newMode = true;
      this.editMode = true;

      if (this.selectedKeyWordObject) {
        this.previousSelectedKeyWordId = this.selectedKeyWordObject.id;
      } else {
        this.previousSelectedKeyWordId = -1;
      }

      this.selectedKeyWordObject = {
        keywordContents: [
          { value: "", language: "de-CH" },
          { value: "", language: "fr-CH" },
          { value: "", language: "it-CH" },
        ],
      };
    },
    onKeyWordChanged(item) {
      this.loadSingleKeyword(item.id);
    },
    loadSingleKeyword(id, sendUpdateNotification) {
      this.errorObject = null;
      this.isSingleKeyWordLoading = true;
      this.editMode = false;
      this.newMode = false;

      if (id == -1) {
        this.isSingleKeyWordLoading = false;
        this.selectedKeyWordObject = null;
        return;
      }

      GetKeyword(
        id,
        (result) => {
          this.selectedKeyWordObject = result;
          this.isSingleKeyWordLoading = false;
          this.previousSelectedKeyWordObject = result;

          if (sendUpdateNotification != null && sendUpdateNotification) {
            this.$emit("keyword-updated", this.selectedKeyWordObject);
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    removeContract(item) {
      this.selectedKeyWordObject.keywordContracts =
        this.selectedKeyWordObject.keywordContracts.filter((filterItem) => {
          return filterItem.contractNumber != item.contractNumber;
        });
    },
    deleteSelectedKeyWord() {
      this.isLoading = true;

      DeleteKeyword(
        this.selectedKeyWordObject.id,
        () => {
          this.selectedKeyWordObject = null;
          this.editMode = false;
          this.isLoading = false;

          this.$emit("keyword-deleted");
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },

    cancelEditingKeyword() {
      if (this.selectedKeyWordObject.id) {
        this.loadSingleKeyword(this.selectedKeyWordObject.id);
      } else {
        this.editMode = false;
        this.newMode = false;
        this.selectedKeyWordObject = JSON.parse(
          JSON.stringify(this.previousSelectedKeyWordObject),
        );
      }
    },

    filterContracts: (option, search) => {
      let temp = search.toLowerCase();
      return (
        option.contractNumber.toLowerCase().indexOf(temp) > -1 ||
        option.contractName.toLowerCase().indexOf(temp) > -1
      );
    },

    getContractName(contractNumber) {
      var contract = this.allContracts.find((element) => {
        return element.contractNumber == contractNumber;
      });

      if (contract == null) {
        return "-";
      }

      return contract.contractName;
    },
  },
};
</script>

<style>
.contractSelection div[role="listitem"] .v-list__tile {
  height: auto;
  padding-top: 7px;
  padding-bottom: 7px;
}
</style>

<style scoped>
.loadingGif {
  height: 200px;
  width: 200px;
  position: relative;
  left: 25%;
}
.mutliselectSelectionItem {
  padding: 4px 11px;
  background-color: rgb(0, 140, 255);
  color: white;
  border-radius: 5px;
}
.mutliselectSelectionItem i {
  margin-left: 5px;
  font-size: 14px;
}
</style>
